// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-l_gT","advertDetailContacts__header":"c-l_gU"};